import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import routes from './routes';
import bus from './eventBus';
import 'animate.css';
import 'reset.css';
import './configs/index';
import store from './stores/index';
import NetVue from './net/http.vue';
import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/tracing';

Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.use(bus);
Vue.use(NetVue);

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(routes),
        tracingOrigins: ['localhost', 'movingkite.com', /^\//],
      }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: process.env.VUE_APP_SENTRY_TRACES_SAMPLE_RATE,
    environment: process.env.VUE_APP_SENTRY_ENVIRONMENT,
    enabled: !process.env.VUE_APP_SENTRY_ENVIRONMENT.includes('local'),
  });
}

new Vue({
  render: h => h(App),
  router: routes,
  store: store,
}).$mount('#app');

routes.afterEach(to => {
  if (to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = 'MOVINGKITE | On-Demand Storage at $0.01/lb/day';
  }
});
